// src/pages/StateWiseSchemes.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import API from "../api/api";
import "./StateWiseSchemes.css";

export default function StateWiseSchemes() {
  const { stateName } = useParams();
  const decoded = decodeURIComponent(stateName);

  const [schemes, setSchemes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSchemes();
  }, [decoded]);

  const loadSchemes = async () => {
    try {
      const res = await API.get(`/states/${encodeURIComponent(decoded)}`);
      const rawSchemes = res.data.data || [];

      // 🔥 APPLY VISIBILITY FILTERS
      const visibleSchemes = rawSchemes
        .filter((scheme) => scheme.showInState === true) // scheme-level visibility
        .map((scheme) => {
          const visibleCats = (scheme.categories || [])
            .filter((cat) => cat.showInState === true) // category visible
            .map((cat) => ({
              ...cat,
              subcategories: (cat.subcategories || []).filter(
                (sub) => sub.showInState === true // sub visible
              ),
            }))
            .filter((cat) => cat.subcategories.length > 0); // must contain visible subcategories

          return { ...scheme, categories: visibleCats };
        })
        .filter((scheme) => scheme.categories.length > 0); // must contain visible categories

      setSchemes(visibleSchemes);
    } catch (err) {
      console.error("Failed loading state schemes", err);
    }

    setLoading(false);
  };

  if (loading)
    return (
      <div className="text-center mt-5 fw-bold fs-4 text-primary">
        Loading...
      </div>
    );

  return (
    <div className="container mt-4 mb-5">
      <h2 className="page-title fw-bold text-center mb-4">{decoded}</h2>

      <div className="row g-4">
        {schemes.map((scheme) =>
          scheme.categories.map((cat, i) => (
            <div key={scheme._id + i} className="col-md-4 col-sm-6 col-12">
              <div className="card shadow-sm category-card h-100">
                <div className="card-body text-center">

                  {/* CATEGORY NAME */}
                  <h5 className="category-title">{cat.name}</h5>

                  {/* SUBCATEGORY COUNT (only visible ones) */}
                  <p className="category-subcount">
                    {cat.subcategories.length} Subcategories
                  </p>

                  {/* BUTTON */}
                  <Link
                    to={`/state-category/${encodeURIComponent(cat.name)}/${encodeURIComponent(decoded)}`}
                    className="btn btn-view-all"
                  >
                    View All →
                  </Link>

                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {schemes.length === 0 && (
        <p className="text-center text-muted mt-4">
          No schemes found for this state.
        </p>
      )}
    </div>
  );
}
